import PropTypes from 'prop-types';
import React from 'react';
import { ProcedureDropdown } from '@zocdoc-frontend-common/components-proceduredropdown';

import EmergencyNotice from '../EmergencyNotice';
import ProcedureDropdownWithTooltip from './ProcedureDropdownWithTooltip';

const ProcedureDropdownBlock = ({
    procedureId,
    procedureMayNotBeCovered,
    providerId,
    showEmergencyNotice,
}) => {
    return (
        <div>
            {procedureMayNotBeCovered ? (
                <ProcedureDropdownWithTooltip
                    dropdownDataTest="procedure-dropdown-select"
                    providerId={providerId}
                    selected={procedureId}
                />
            ) : (
                <ProcedureDropdown
                    dropdownDataTest="procedure-dropdown-select"
                    providerId={providerId}
                    selected={procedureId}
                />
            )}

            <EmergencyNotice showEmergencyNotice={showEmergencyNotice} />
        </div>
    );
};

ProcedureDropdownBlock.propTypes = {
    procedureId: PropTypes.string,
    ProcedureMayNotBeCovered: PropTypes.bool,
    providerId: PropTypes.string,
    showEmergencyNotice: PropTypes.bool,
};

export default ProcedureDropdownBlock;
